module.exports = __webpack_public_path__ + "static/img/plug3.40f68150.png";